import AppConstants from '../config/app.constants';

let LocationService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data) => {
        return $http
            .post(AppConstants.api + `/location/create`, data)
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/location/${id}`, { params: { branchId } })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data) => {
        return $http
            .post(AppConstants.api + `/location/${encodeURIComponent(id)}`, data)
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/location/${encodeURIComponent(id)}`)
            .then((res) => {
                return res.data
            })
    }

    let holdLocation = (locationId, routeId, date, reason, comments, supervisorId) => {
        return $http
            .post(AppConstants.api + `/location/${locationId}/hold`, {
                routeId,
                date,
                reason,
                comments,
                supervisorId
            })
            .then((res) => {
                return res.data
            })
    }

    let getVisitingRoutes = (locationId, day) => {
        return $http
            .get(AppConstants.api + `/location/${locationId}/visiting-routes?day=${day}`)
            .then((res) => {
                return res.data
            });
    }


    let getCoveringZones = (locationId, branchIds) => {
        return $http
            .get(AppConstants.api + `/location/${encodeURIComponent(locationId)}/covering-zones`, {
                params: { branchIds: (branchIds || []).join(',') }
            })
            .then((res) => {
                return res.data
            });
    }

    let getPickupRequestTimes = () => {
        return $http
            .get(AppConstants.api + `/pickup-request/getRequestTimeStatus`)
            .then((res) => {
                return {
                    status: true,
                    data: res.data.results || res.data
                }
            });
    }

    let getBagoutData = (locationId, startDate, endDate) => {
        return $http
            .get(AppConstants.api + `/location/bagOutData/${locationId}?startDate=${startDate}&endDate=${endDate}`)
            .then((res) => {
                return res.data
            })
    }

    let getAllLocation = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let centralBankLocation = (branch) => {
        return $http
            .get(AppConstants.api + `/location/central-bank-location`, {
                params: {
                    branch
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let shipmentRoutes = (locations) => {
        return $http
            .get(AppConstants.api + `/location/shipment-routes`, {
                params: {
                    locations
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let bulkHoldLocations = (data, branchId) => {
        if (!data.length) return [];
        return $http
            .post(AppConstants.api + `/location/bulk-hold`, {
                data,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let fixGeocoding = (branchId, locationIds) => {
        return $http
            .post(AppConstants.api + `/location/fix-geocoding`, {
                branchId,
                locationIds
            })
            .then((res) => {
                return res.data
            })
    }

    let exportLocations = (searchText, locationType, status, branch, customerId, filterByAllBranch, userId) => {
        return $http
            .post(AppConstants.api + `/location/export-locations`, {
                searchText,
                locationType,
                status,
                branch,
                customerId,
                filterByAllBranch,
                userId
            })
            .then((res) => {
                return res.data
            })
    }

    let getLocationUpdateHistory = (locationId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/location/get-location-update-history`, {
                params: {
                    locationId,
                    limit,
                    offset
                }
            })
            .then((res) => {
                return res.data
            });
    }

    let saveLocationChanges = (extraDetails, routeAssignment, deliveryToLocation, duration, status, allBranches, defaultBranch, batchImport, bagoutExport, handleAtmLikeRegular, recurringRouteAssignment, denomination, scheduleRecurringLoad, fundingSource) => {
        return $http
            .post(AppConstants.api + `/location/save-location-changes`, {
                extraDetails,
                routeAssignment,
                deliveryToLocation,
                duration,
                status,
                allBranches,
                defaultBranch,
                batchImport,
                bagoutExport,
                handleAtmLikeRegular,
                recurringRouteAssignment,
                denomination,
                scheduleRecurringLoad,
                fundingSource,
            })
            .then((res) => {
                return res.data
            })
    }

    let getPendingLocationChanges = (id) => {
        return $http
            .get(AppConstants.api + `/location/get-pending-location-changes`, {
                params: {
                    id
                }
            })
            .then((res) => {
                return res.data
            });
    }

    let removeLocationChanges = (jobId) => {
        return $http
            .post(AppConstants.api + `/location/remove-location-changes`, { jobId })
            .then((res) => {
                return res.data
            });
    }

    let getPendingLocationChangesIds = () => {
        return $http
            .get(AppConstants.api + `/location/get-location-ids`)
            .then((res) => {
                return res.data
            })
    };

    let getBankDeliverLocations = (searchText, branchId, destinationLocation, offset, limit, customerId, useBatchId) => {
        return $http
            .get(AppConstants.api + `/location/get-bank-delivered-location`, {
                params: {
                    searchText,
                    branchId,
                    destinationLocation,
                    offset,
                    limit,
                    customerId,
                    useBatchId
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getBranchLocationList = (searchText, branchId, customerId, offset, limit) => {
        return $http
            .get(AppConstants.api + '/location/get-branch-locations', {
                params: {
                    searchText,
                    branchId,
                    customerId,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let hasCustomerLocation = (locationId, customerId, branchId) => {
        return $http
            .get(AppConstants.api + '/location/has-customer-location', {
                params: {
                    locationId, customerId, branchId
                }
            })
            .then((res) => {
                res.data
            })
    }

    let sendDeliveryOrPickupReceipt = (trackingId, locationId, branchId, routeId, vaultDate, emails, selectedDepositAmountValue, timezone, tranType) => {
        return $http
            .post(AppConstants.api + `/location/send-delivery-or-pickup-receipt`, {
                trackingId, locationId, branchId, routeId, vaultDate, emails, selectedDepositAmountValue, timezone, tranType
            })
            .then((res) => {
                return res.data
            })
    }

    let sendOrderReceipt = (orderNo, locationId, branchId, routeId, vaultDate, emails) => {
        return $http
            .post(AppConstants.api + `/location/send-order-receipt`, {
                orderNo, locationId, branchId, routeId, vaultDate, emails
            })
            .then((res) => {
                return res.data
            })
    }

    let getLocationDrivingDistance = (locationAddress, branchAddress) => {
        return $http
            .get(AppConstants.api + '/location/get-location-driving-distance', {
                params: { locationAddress, branchAddress }
            })
            .then((res) => {
                return res.data
            })
    }

    let updateLocationDrivingDistance = (filterByAllBranch, branchId) => {
        return $http
            .post(AppConstants.api + `/location/update-location-driving-distance`, {
                filterByAllBranch, branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let getCombinedLocationRecurring = (id) => {
        return $http
            .get(AppConstants.api + `/location/getCombinedLocationRecurring/${encodeURIComponent(id)}`)
            .then((res) => {
                return res.data
            })
    }

    let bulkUpdateLocationDistance = (branchId) => {
        return $http
            .post(AppConstants.api + `/location/bulk-update-location-distance`, { branchId })
            .then((res) => {
                return res.data
            })
    }

    let calculateDayOccurrences = (locationId, dayOfWeek, anchorDate, interval, frequency, sequence, branchId) => {
        return $http
            .get(AppConstants.api + `/location/${locationId}/calculate-day-occurrences`, {
                params: {
                    dayOfWeek, anchorDate, interval, frequency, sequence, branchId
                }
            })
            .then((res) => {
                return res.data;
            })
    }

    let getBillingRulesByLocationId = (locationId, offset, limit, startDate, endDate) => {
        return $http
                .get(AppConstants.api+`/location/${locationId}/get-billing-rules-by-location`, {
                    params: {
                        limit,
                        offset,
                        locationId,
                        startDate,
                        endDate
                    }
                })
                .then((res) => {
                    return res.data
                })
    }

    let getBillingHistory = (locationId, offset, limit, startDate, endDate) => {
        return $http
                .get(AppConstants.api+`/location/${locationId}/get-billing-history`, {
                    params: {
                        limit,
                        offset,
                        locationId,
                        startDate,
                        endDate
                    }
                })
                .then((res) => {
                    return res.data
                })
    }

    let exportBillingRulesByLocationId = (locationId, startDate, endDate) => {
        return $http
                .get(AppConstants.api+`/location/${locationId}/export-billing-rules-by-location`, {
                    params: {
                        locationId,
                        startDate,
                        endDate
                    }
                })
                .then((res) => {
                    return res.data
                })
    }

    let exportBillingHistory = (locationId, startDate, endDate) => {
        return $http
                .get(AppConstants.api+`/location/${locationId}/export-billing-history`, {
                    params: {
                        locationId,
                        startDate,
                        endDate
                    }
                })
                .then((res) => {
                    return res.data
                })
    }

    let getLocationServiceZone = (branchId, locationId) => {
        return $http
            .get(AppConstants.api + '/location/get-location-service-zone', {
                params: {
                    branchId,
                    locationId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getLocationLogs = (locationId, search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location/${locationId}/get-location-logs`, {
                params: {
                    locationId, search, offset, limit
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let getShipmentDestinations = (branchId, fromLocationId, searchKey, offset, limit) => {
        return $http
            .get(AppConstants.api + `/location/get-shipment-destinations`, {
                params: { branchId, fromLocationId, searchKey, offset, limit },
            })
            .then((res) => res.data)
    }

    let getNextValutDateOfLocation = (locationId, branchId) => {
        return $http
            .get(AppConstants.api + `/location/get-next-vault-date`, {
                params: { locationId, branchId },
            })
            .then((res) => res.data)
    }

    let getNextVaultDateRoute = (locationId, branchId, vaultDate) => {
        return $http
            .get(AppConstants.api + `/pickup-request-management/get-next-vault-date-and-route`, {
                params: { locationId, branchId, vaultDate },
            })
            .then((res) => res.data)
    }

    let cloneLocation = (data) => {
        return $http
            .post(AppConstants.api + `/location/clone`, data)
            .then((res) => res.data)
            .catch((err) => {
                return Promise.reject(err);
            });
    }

    let validateLocationIds = (locationIds) => {
        return $http
            .post(AppConstants.api + `/location/validate-ids`, { locationIds })
            .then((res) => res.data)
            .catch((err) => {
                return Promise.reject(err);
            });
    }

    let getDeliveryToLocationsAndShiptypes = (locationId, searchKey) => {
        return $http
            .get(AppConstants.api + `/location/get-delivery-locations-and-shiptypes`, {
                params: {
                    locationId, searchKey
                }
            })
            .then((res) => res.data)
    }

    let getPreventativeMaintenanceList = (limit, offset, searchText) => {
        return $http
            .get(AppConstants.api + `/preventative-maintenance`, {
                params: { limit, offset, searchText }
            })
            .then((res) => {
                return res.data;
            });
    }
    let getPreventativeMaintenance = (id) => {
        return $http
            .get(AppConstants.api + `/preventative-maintenance/` + id)
            .then((res) => {
                return res.data;
            });
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        holdLocation,
        getVisitingRoutes,
        getCoveringZones,
        getPickupRequestTimes,
        getBagoutData,
        getAllLocation,
        centralBankLocation,
        shipmentRoutes,
        bulkHoldLocations,
        fixGeocoding,
        exportLocations,
        getLocationUpdateHistory,
        saveLocationChanges,
        getPendingLocationChanges,
        removeLocationChanges,
        getPendingLocationChangesIds,
        getBankDeliverLocations,
        getBranchLocationList,
        hasCustomerLocation,
        sendDeliveryOrPickupReceipt,
        sendOrderReceipt,
        getLocationDrivingDistance,
        updateLocationDrivingDistance,
        getCombinedLocationRecurring,
        calculateDayOccurrences,
        bulkUpdateLocationDistance,
        getBillingRulesByLocationId,
        getBillingHistory,
        exportBillingRulesByLocationId,
        exportBillingHistory,
        getLocationServiceZone,
        getLocationLogs,
        getShipmentDestinations,
        getNextValutDateOfLocation,
        getNextVaultDateRoute,
        cloneLocation,
        validateLocationIds,
        getDeliveryToLocationsAndShiptypes,
        getPreventativeMaintenanceList,
        getPreventativeMaintenance
    };
};

LocationService.$inject = ['$http', '$q']

export default LocationService;



// WEBPACK FOOTER //
// ./client/app/services/location.service.js